import React, { useState, useEffect } from "react";
import { Button, Grid } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { useTranslation } from "react-i18next";
import { useDispatch, connect } from "react-redux";
import { setAlert } from "../redux/actions/appSettingsActions";
import { Markup } from "interweave";

function AlertDialog(props) {
  const { t, i18n } = useTranslation("timeOutPage");
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setAlert({ isAlert: false, alertMsg: "" }));
  };

  return (
    <Dialog open={props.settings.alert.isAlert}>
      <DialogTitle>{t("warningTitle")}</DialogTitle>
      <DialogContent>
        <Grid container alignItems="center" justify="center">
          <Grid item md={2} justify="center">
            <ReportProblemOutlinedIcon
              style={{ fontSize: 60, color: "#ffb74d" }}
            />
          </Grid>
          <Grid item md={10}>
            <DialogContentText color="textPrimary">
              <Markup content={props.settings.alert.alertMsg} />
            </DialogContentText>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("closeBtn")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    settings: state.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
